import { createUseStyles } from "react-jss";
import { ICustomThemeParams } from "../../../../lib/types/styles";


export const styles = createUseStyles({
    image : {
        // width: '200px',
        minHeight: '150px',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        cursor:'pointer'
    }
})